import { v4 as uuidv4 } from 'uuid';
import { Partner, Society, SocietyChart } from 'types';

import {
  getPartnerActualShares,
  getPartnerByCif,
  getPartnerFDPercent,
  getPartnerNDPercent,
} from 'utils/filters';

import CHART_COMPANY_LOGO from 'assets/images/logo-company.png';
import { getHoldingReference } from './getHoldingReference';

const getHoldingInfoForChart = (
  societiesArray: Society[][],
  actualSociety: Society,
  partners: Partner[]
): SocietyChart[][] => {
  const holdingInfo = societiesArray?.map((currentSocieties, index) =>
    currentSocieties.map((parentSociety: Society) => {
      const childSociety: Society =
        index > 0 ? societiesArray[index - 1][0] : actualSociety;

      const parentSocietyPartners: Partner[] = parentSociety?.partners || [];
      const partner: Partner | null = getPartnerByCif(parentSocietyPartners, childSociety.cif);

      const holdingKey: string = uuidv4();
      const holdingId: string = parentSociety?._id;
      const holdingCIF: string = parentSociety?.cif;
      const holdingName: string = parentSociety?.name;
      const holdingLogo: string = parentSociety?.additional?.logo || CHART_COMPANY_LOGO;
      const holdingReferenceLevel: number = index;
      const holdingReference: string[] | null = getHoldingReference({ index, partners, previousSocieties: societiesArray[index - 1], actualSociety })

      const holdingShares = partner ? getPartnerActualShares(partner._id, parentSocietyPartners) : 0;
      const holdingPercentND = partner ? getPartnerNDPercent(partner, parentSociety) : 0;
      const holdingPercentFD = partner ? getPartnerFDPercent(partner, parentSociety) : 0;

      return {
        holdingId,
        holdingName,
        holdingCIF,
        holdingLogo,
        holdingShares,
        holdingPercentND,
        holdingPercentFD,
        holdingReference,
        holdingReferenceLevel,
        holdingKey,
      };
    })
  );

  return holdingInfo;
};

export default getHoldingInfoForChart;
